import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Зээл бүртгэх")
const _hoisted_5 = { class: "row g-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "row g-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "row g-10" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = {
  key: 1,
  class: "card card-stretch shadow mb-5"
}
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h5", { align: "center" }, " Байгууллагын удирдлагын талаарх мэдээлэл ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_45 = { class: "col-lg-6" }
const _hoisted_46 = {
  key: 1,
  class: "card card-stretch shadow mb-5"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, [
      /*#__PURE__*/_createElementVNode("i", {
        class: "fas fa-coins fs-5 me-3",
        style: {"color":"black"}
      }),
      /*#__PURE__*/_createTextVNode(" Зээл")
    ])
  ])
], -1)
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_51 = { class: "el-input el-input--mini" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_53 = { style: {"float":"left"} }
const _hoisted_54 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_63 = { class: "el-input el-input--mini" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_67 = { class: "card-footer" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-save fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Бүртгэх ")
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-save fs-5 me-3",
  style: {"color":"white"}
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Бүртгэх ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (
      this.role.includes('ROLE_FORM_MENU') || this.role.includes('ROLE_ADMIN')
    )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_alert, {
              description: this.version,
              title: "Санамж!",
              type: "warning"
            }, null, 8, ["description"])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectStatus.selectStatusVal,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectStatus.selectStatusVal) = $event)),
              placeholder: "Select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectStatus.data, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.selectStatusVal,
                    label: item.selectStatusLabel,
                    value: item.selectStatusVal
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (this.dataLoading)
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    rows: 5,
                    animated: ""
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h3", _hoisted_13, [
                        _createElementVNode("b", null, [
                          _createElementVNode("i", {
                            class: _normalizeClass(
                      this.selectStatus.selectStatusVal === '01'
                        ? 'fas fa-user fs-5 me-3'
                        : 'fas fa-building fs-5 me-3'
                    ),
                            style: {"color":"black"}
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(this.selectStatus.selectStatusVal === "01"
                      ? "Иргэн"
                      : "Хуулийн этгээд"), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (this.selectStatus.selectStatusVal === '01')
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 0,
                            model: this.citizenCustForm,
                            rules: this.citizenCustFormRule,
                            ref: "citizenCustFormRef",
                            "label-width": "150px",
                            "label-position": "left",
                            size: "mini"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "Хуулийн статус:",
                                "label-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: 
                        _ctx.citizenCustForm.selectStatusCitizen.selectValCitizen
                      ,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((
                        _ctx.citizenCustForm.selectStatusCitizen.selectValCitizen
                      ) = $event)),
                                    placeholder: "Хуулийн статус",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citizenCustForm.selectStatusCitizen.data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.selectValCitizen,
                                          label: item.selectLabelCitizen,
                                          value: item.selectValCitizen
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_15,
                              _createVNode(_component_el_form_item, {
                                label: "Регистрийн дугаар:",
                                prop: "registerno",
                                "label-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.citizenCustForm.registerno,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.citizenCustForm.registerno) = $event)),
                                    placeholder: 
                        _ctx.citizenCustForm.selectStatusCitizen.selectValCitizen ===
                        '01'
                          ? 'AB________'
                          : ''
                      
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              }),
                              _hoisted_16,
                              _createVNode(_component_el_form_item, {
                                label: "Иргэний үнэмлэх №:",
                                "label-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.citizenCustForm.passportno,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.citizenCustForm.passportno) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_17,
                              _createVNode(_component_el_form_item, {
                                label: "Овог:",
                                "label-width": "",
                                prop: "surname"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.citizenCustForm.surname,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.citizenCustForm.surname) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_18,
                              _createVNode(_component_el_form_item, {
                                label: "Нэр:",
                                "label-width": "",
                                prop: "givenname"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.citizenCustForm.givenname,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.citizenCustForm.givenname) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_19,
                              _createVNode(_component_el_form_item, {
                                label: "Төрсөн огноо:",
                                "label-width": "",
                                prop: "birthdate"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.citizenCustForm.birthdate,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.citizenCustForm.birthdate) = $event)),
                                    type: "date",
                                    placeholder: "Он сар өдөр",
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_20,
                              _createVNode(_component_el_form_item, {
                                label: "Зип код:",
                                "label-width": "",
                                prop: "zipcode"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.citizenCustForm.zipcode,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.citizenCustForm.zipcode) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_21,
                              _createVNode(_component_el_form_item, {
                                label: "Хаяг:",
                                "label-width": "",
                                prop: "address"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    autosize: "",
                                    modelValue: _ctx.citizenCustForm.address,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.citizenCustForm.address) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_22,
                              _createVNode(_component_el_form_item, {
                                label: "Мэргэжил:",
                                "label-width": "",
                                prop: "selectOccupationCitizen.itemid"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.citizenCustForm.selectOccupationCitizen.itemid,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.citizenCustForm.selectOccupationCitizen.itemid) = $event)),
                                    placeholder: "--Сонгох--",
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.citizenCustForm.selectOccupationCitizen
                          .data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.itemid,
                                          label: item.name1,
                                          value: item.itemid
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_23,
                              _createVNode(_component_el_form_item, {
                                label: "Эрхэлдэг ажил:",
                                "label-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    autosize: "",
                                    modelValue: _ctx.citizenCustForm.job,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.citizenCustForm.job) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_24,
                              _createVNode(_component_el_form_item, {
                                label: "Гэр бүлийн гишүүдийн тоо:",
                                "label-width": "200px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.citizenCustForm.familymembers,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.citizenCustForm.familymembers) = $event)),
                                    "controls-position": "right",
                                    min: 1,
                                    max: 50
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_25,
                              _createVNode(_component_el_form_item, {
                                label: "Ажилгүй гишүүдийн тоо:",
                                "label-width": "200px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.citizenCustForm.unemployedmembers,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.citizenCustForm.unemployedmembers) = $event)),
                                    "controls-position": "right",
                                    min: 1,
                                    max: 50
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"]))
                        : (_openBlock(), _createBlock(_component_el_form, {
                            key: 1,
                            model: this.orgCustForm,
                            rules: this.orgCustFormRule,
                            ref: "orgCustFormRef",
                            "label-width": "150px",
                            "label-position": "left",
                            size: "mini"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "Хуулийн статус:",
                                "label-width": "",
                                prop: "selectStatusOrg.selectValOrg"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.orgCustForm.selectStatusOrg.selectValOrg,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.orgCustForm.selectStatusOrg.selectValOrg) = $event)),
                                    placeholder: "--Сонгох--",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgCustForm.selectStatusOrg.data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.selectValOrg,
                                          label: item.selectLabelOrg,
                                          value: item.selectValOrg
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_26,
                              _createVNode(_component_el_form_item, {
                                label: "Монгол улсад бүртгэлтэй эсэх:",
                                "label-width": "230px",
                                prop: "isforeign"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.orgCustForm.isforeign,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.orgCustForm.isforeign) = $event)),
                                    placeholder: "--Сонгох--",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: "Бүртгэгдсэн",
                                        value: "1"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Бүртгэгдээгүй",
                                        value: "0"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_27,
                              _createVNode(_component_el_form_item, {
                                label: "Регистрийн дугаар:",
                                "label-width": "",
                                prop: "registerno"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.orgCustForm.registerno,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.orgCustForm.registerno) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_28,
                              _createVNode(_component_el_form_item, {
                                label: "Улсын бүртгэлийн дугаар:",
                                "label-width": "230px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.orgCustForm.stateregnum,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.orgCustForm.stateregnum) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_29,
                              _createVNode(_component_el_form_item, {
                                label: "Нэр:",
                                "label-width": "",
                                prop: "givenname"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.orgCustForm.givenname,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.orgCustForm.givenname) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_30,
                              _createVNode(_component_el_form_item, {
                                label: "Хариуцлагын хэлбэр:",
                                "label-width": "230px",
                                prop: "selectCompanyTypeCode.itemid"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.orgCustForm.selectCompanyTypeCode.itemid,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.orgCustForm.selectCompanyTypeCode.itemid) = $event)),
                                    placeholder: "--Сонгох--",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgCustForm.selectCompanyTypeCode.data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.itemid,
                                          label: item.name1,
                                          value: item.itemid
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_31,
                              _createVNode(_component_el_form_item, {
                                label: "Байгуулагдсан огноо:",
                                "label-width": "230px",
                                prop: "birthdate"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.orgCustForm.birthdate,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.orgCustForm.birthdate) = $event)),
                                    type: "date",
                                    placeholder: "Он сар өдөр",
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_32,
                              _createVNode(_component_el_form_item, {
                                label: "Зип код:",
                                "label-width": "",
                                prop: "zipcode"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.orgCustForm.zipcode,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.orgCustForm.zipcode) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_33,
                              _createVNode(_component_el_form_item, {
                                label: "Хаяг:",
                                "label-width": "",
                                prop: "address"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    autosize: "",
                                    modelValue: _ctx.orgCustForm.address,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.orgCustForm.address) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_34,
                              _createVNode(_component_el_form_item, {
                                label: "Үйл ажиллагааны чиглэлийн тоо:",
                                "label-width": "230px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.orgCustForm.numofmainsector,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.orgCustForm.numofmainsector) = $event)),
                                    "controls-position": "right",
                                    min: 1,
                                    max: 50,
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_35,
                              _createVNode(_component_el_form_item, {
                                label: "Нийт ажиллагсадын тоо:",
                                "label-width": "230px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.orgCustForm.numofemployee,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.orgCustForm.numofemployee) = $event)),
                                    "controls-position": "right",
                                    min: 1,
                                    max: 50,
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_36,
                              _createVNode(_component_el_form_item, {
                                label: "Fitch Rating:",
                                "label-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.orgCustForm.selectFitchRating.itemid,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.orgCustForm.selectFitchRating.itemid) = $event)),
                                    placeholder: "--Сонгох--",
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgCustForm.selectFitchRating.data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.itemid,
                                          label: item.name1,
                                          value: item.itemid
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_37,
                              _createVNode(_component_el_form_item, {
                                label: "Sandp Rating:",
                                "label-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.orgCustForm.selectSandpRating.itemid,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.orgCustForm.selectSandpRating.itemid) = $event)),
                                    placeholder: "--Сонгох--",
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgCustForm.selectSandpRating.data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.itemid,
                                          label: item.name1,
                                          value: item.itemid
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_38,
                              _createVNode(_component_el_form_item, {
                                label: "Moodys Rating:",
                                "label-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.orgCustForm.selectMoodysRating.itemid,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.orgCustForm.selectMoodysRating.itemid) = $event)),
                                    placeholder: "--Сонгох--",
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgCustForm.selectMoodysRating.data, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.itemid,
                                          label: item.name1,
                                          value: item.itemid
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_39,
                              _hoisted_40,
                              _hoisted_41,
                              _createVNode(_component_el_form_item, {
                                label: "Монгол улсын иргэн эсэх:",
                                "label-width": "230px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.orgCustForm.socialPresident,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.orgCustForm.socialPresident) = $event)),
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: "Тийм",
                                        value: "01",
                                        "aria-selected": "true"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Үгүй",
                                        value: "02"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_42,
                              _createVNode(_component_el_form_item, {
                                label: "Регистрийн дугаар:",
                                "label-width": "",
                                prop: "registernoPre"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.orgCustForm.registernoPre,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.orgCustForm.registernoPre) = $event)),
                                    placeholder: 
                        _ctx.orgCustForm.socialPresident === '01' ? 'AB________' : ''
                      
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              }),
                              _hoisted_43,
                              _createVNode(_component_el_form_item, {
                                label: "Овог:",
                                "label-width": "",
                                prop: "presidentsurname"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.orgCustForm.presidentsurname,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.orgCustForm.presidentsurname) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _hoisted_44,
                              _createVNode(_component_el_form_item, {
                                label: "Нэр:",
                                "label-width": "",
                                prop: "presidentgivenname"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.orgCustForm.presidentgivenname,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.orgCustForm.presidentgivenname) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"]))
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_45, [
              (this.dataLoading)
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    rows: 5,
                    animated: ""
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_el_form, {
                        ref: "loanFormRef",
                        model: this.loanForm,
                        rules: this.loanFormRule,
                        "label-width": "150px",
                        "label-position": "left",
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "Төрөл:",
                            "label-width": "",
                            prop: "loantype"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.loanForm.selectLoanType.itemid,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.loanForm.selectLoanType.itemid) = $event)),
                                placeholder: "--Сонгох--",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectLoanType.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.itemid,
                                      label: item.name1,
                                      value: item.itemid
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_49,
                          _createVNode(_component_el_form_item, {
                            label: "Ангилал:",
                            "label-width": "",
                            prop: "loanclass"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.loanForm.selectLoanClass.itemid,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.loanForm.selectLoanClass.itemid) = $event)),
                                placeholder: "--Сонгох--",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectLoanClass.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.itemid,
                                      label: item.name1,
                                      value: item.itemid
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_50,
                          _createVNode(_component_el_form_item, {
                            label: "Олгосон зээлийн хэмжээ:",
                            "label-width": "200px",
                            prop: "advamount"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_VueNumberFormat, {
                                  class: "el-input__inner",
                                  value: this.loanForm.advamount,
                                  "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((this.loanForm.advamount) = $event))
                                }, null, 8, ["value"])
                              ])
                            ]),
                            _: 1
                          }),
                          _hoisted_52,
                          _createVNode(_component_el_form_item, {
                            label: "Валютын код:",
                            "label-width": "200px",
                            prop: "currency"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.loanForm.selectCurrency.currencycode,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.loanForm.selectCurrency.currencycode) = $event)),
                                placeholder: "--Сонгох--",
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectCurrency.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.currencycode,
                                      label: item.monname,
                                      value: item.currencycode
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_53, _toDisplayString(item.monname), 1),
                                        _createElementVNode("span", _hoisted_54, _toDisplayString(item.currencycode), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_55,
                          _createVNode(_component_el_form_item, {
                            label: "Зээл олгосон огноо:",
                            "label-width": "200px",
                            prop: "startdate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.loanForm.startdate,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.loanForm.startdate) = $event)),
                                type: "datetime",
                                placeholder: "Он сар өдөр цаг минут секунд",
                                style: {"width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_56,
                          _createVNode(_component_el_form_item, {
                            label: "Төлөгдөх огноо:",
                            "label-width": "200px",
                            prop: "expdate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.loanForm.expdate,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.loanForm.expdate) = $event)),
                                type: "date",
                                placeholder: "Он сар өдөр",
                                style: {"width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_57,
                          _createVNode(_component_el_form_item, {
                            label: "Зээлийн зориулалт:",
                            "label-width": "200px",
                            prop: "selectLoanPurpose1.sectorcode"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.loanForm.selectLoanPurpose1.sectorcode,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.loanForm.selectLoanPurpose1.sectorcode) = $event)),
                                placeholder: "--Сонгох--",
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectLoanPurpose1.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.sectorcode,
                                      label: item.sectorname,
                                      value: item.sectorcode
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_58,
                          (this.loanForm.selectLoanPurpose1.sectorcode)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                "label-width": "",
                                prop: "selectLoanPurpose2.subsectorcode"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.loanForm.selectLoanPurpose2.subsectorcode,
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.loanForm.selectLoanPurpose2.subsectorcode) = $event)),
                                    placeholder: "--Сонгох--",
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectLoanPurpose2.data.filter(
                        data => {
                          return (
                            !this.loanForm.selectLoanPurpose1.sectorcode ||
                            data.sectorcode.includes(
                              this.loanForm.selectLoanPurpose1.sectorcode
                            )
                          );
                        }
                      ), (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.subsectorcode,
                                          label: item.subsectorname,
                                          value: item.subsectorcode
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _hoisted_59,
                          _createVNode(_component_el_form_item, {
                            label: "Зээлийн үүсэл:",
                            "label-width": "",
                            prop: "selectLoanSource.itemid"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.loanForm.selectLoanSource.itemid,
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.loanForm.selectLoanSource.itemid) = $event)),
                                placeholder: "--Сонгох--",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectLoanSource.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.itemid,
                                      label: item.name1,
                                      value: item.itemid
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_60,
                          _createVNode(_component_el_form_item, {
                            label: "Хүүгийн % /жил/:",
                            "label-width": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "number",
                                placeholder: "0.0%",
                                modelValue: _ctx.loanForm.interestin,
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.loanForm.interestin) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_61,
                          _createVNode(_component_el_form_item, {
                            label: "Шимтгэлийн хувь:",
                            "label-width": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "number",
                                placeholder: "0.0",
                                modelValue: _ctx.loanForm.comissionin,
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.loanForm.comissionin) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_62,
                          _createVNode(_component_el_form_item, {
                            label: "Хураамжийн хэмжээ:",
                            "label-width": ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_63, [
                                _createVNode(_component_VueNumberFormat, {
                                  class: "el-input__inner",
                                  value: this.loanForm.loanfee,
                                  "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((this.loanForm.loanfee) = $event))
                                }, null, 8, ["value"])
                              ])
                            ]),
                            _: 1
                          }),
                          _hoisted_64,
                          _createVNode(_component_el_form_item, {
                            label: "Зээлийн төлөлтийн хэлбэр:",
                            placeholder: "--Сонгох--",
                            "label-width": "250px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: 
                      _ctx.loanForm.selectloancharttype.selectloancharttypeval
                    ,
                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((
                      _ctx.loanForm.selectloancharttype.selectloancharttypeval
                    ) = $event)),
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectloancharttype.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.selectloancharttypeval,
                                      label: item.selectloancharttypelabel,
                                      value: item.selectloancharttypeval
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_65,
                          _createVNode(_component_el_form_item, {
                            label: "Зээлийн хүүгийн төлөлтийн хэлбэр:",
                            placeholder: "--Сонгох--",
                            "label-width": "250px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: 
                      _ctx.loanForm.selectloaninterestcharttype
                        .selectloancharttypeval
                    ,
                                "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((
                      _ctx.loanForm.selectloaninterestcharttype
                        .selectloancharttypeval
                    ) = $event)),
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loanForm.selectloaninterestcharttype.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.selectloancharttypeval,
                                      label: item.selectloancharttypelabel,
                                      value: item.selectloancharttypeval
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _hoisted_66,
                          _createVNode(_component_el_form_item, {
                            label: "Тайлбар:",
                            "label-width": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "textarea",
                                autosize: "",
                                modelValue: _ctx.loanForm.loandescription,
                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.loanForm.loandescription) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      (this.selectStatus.selectStatusVal === '01')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_button, {
                              type: "success",
                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.formSubmitCust())),
                              size: "small",
                              loading: this.loanForm.savebuttonloading
                            }, {
                              default: _withCtx(() => [
                                _hoisted_68,
                                _hoisted_69
                              ]),
                              _: 1
                            }, 8, ["loading"]),
                            _createVNode(_component_el_button, {
                              type: "success",
                              ref: "submitCustRef",
                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.submitCitizenForm())),
                              size: "small",
                              hidden: ""
                            }, null, 512)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_el_button, {
                              type: "success",
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.formSubmitOrg())),
                              size: "small",
                              loading: this.loanForm.savebuttonloading
                            }, {
                              default: _withCtx(() => [
                                _hoisted_70,
                                _hoisted_71
                              ]),
                              _: 1
                            }, 8, ["loading"]),
                            _createVNode(_component_el_button, {
                              type: "success",
                              ref: "submitOrgRef",
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.submitOrgForm())),
                              size: "small",
                              hidden: ""
                            }, null, 512)
                          ], 64))
                    ])
                  ]))
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}